import React, { ReactElement } from 'react'
import { Link } from 'react-router-dom'
import { Card as AntCard, Descriptions } from 'antd'

interface CardProps {
  title: ReactElement
  path: string
  actionIcon: ReactElement
  actionText: ReactElement
  content: ReactElement
  disabled?: boolean
}

const Card = ({ title, path, actionIcon, actionText, content, disabled = false }: CardProps): ReactElement => {
  
  const CardContent = (
    <AntCard
      className={`vt-card ${disabled ? 'vt-card-disabled' : ''}`}
      hoverable={!disabled}
      key={path}
      actions={[<div key={path}>{actionIcon}&nbsp;{actionText}</div>]}
      title={title}
    >
      <Descriptions layout="horizontal" size="small" column={1}>
        <Descriptions.Item key="desc">
          {content}
        </Descriptions.Item>
      </Descriptions>
    </AntCard>
  )

  return disabled 
    ? CardContent
    : <Link to={path} style={{ textDecoration: 'none' }}>
      {CardContent}
    </Link>

}

export default Card